import autobind from 'autobind-decorator';
import classNames from 'classnames';
import * as React from 'react';

import './styles.scss';

import { SubscriptionType } from 'common/constants/subscription';
import { InformationItem, InformationRow } from '..';
// import { ItemMenu, ItemMenuType } from '../../../../components/controls/item-menu';
import { AdminCompanyVm } from '../../interfaces/admin-company-vm';
import { CompanySubscriptionsControl } from '../company-subscriptions-control.tsx';

interface CompanyItemProps {
  company: AdminCompanyVm;
  isActive?: boolean;
  onClick?: (item: AdminCompanyVm) => void;
  onCleanDeletedProjectsClick?: (companyId: number) => void;
  onDatabasesAttach?: (companyId: number) => void;
  onEmployeesAttach?: (companyId: number, subscriptionType: SubscriptionType) => void;
  onEmployeeClick?: (email: string, subscriptionType: SubscriptionType) => void;
  onDatabaseDetachClick?: (companyId: number, databaseId: number) => void;
  onEmployeeDetachClick?: (companyId: number, employeeGuid: string, subscriptionType: SubscriptionType) => void;
  onOpenDeleteCompanyDialog: (companyId: number) => void;
  createEmptySubscription: (companyId: number, subscriptionType: SubscriptionType) => void;
}

export class CompanyItem extends React.Component<CompanyItemProps>  {
  // private menu: ItemMenuType[] = [
  //   {
  //     name: '',
  //     action: ConstantFunctions.doNothing,
  //   },
  //   {
  //     name: 'Delete all projects',
  //     action: this.deleteProjects,
  //   },
  //   {
  //     name: 'Delete company',
  //     action: this.deleteCompony,
  //   },
  // ];

  public render(): React.ReactNode {
    const { company } = this.props;

    return (
      <div
        className={classNames('admin-item', { active: this.props.isActive })}
        onClick={this.onItemClick}
      >
        <div className='admin-item__information'>
          <span className='admin-item__head'>
            {company.name}
          </span>
          {/* <ItemMenu menu={this.menu} className='admin-item__item-actions-menu' /> */}
        </div>
        <InformationRow>
          <InformationItem
            title='Id'
            data={company.id}
          />
          <InformationItem
            title='Email'
            data={company.email}
          />
        </InformationRow>
        <InformationRow>
          <button onClick={this.openDeleteCompanyDialog} style={{ cursor: 'pointer' }}>
            delete company
          </button>
        </InformationRow>
        <CompanySubscriptionsControl
          company={company}
          createEmptySubscription={this.props.createEmptySubscription}
          onEmployeeClick={this.props.onEmployeeClick}
          onEmployeeDetachClick={this.props.onEmployeeDetachClick}
          onEmployeesAttach={this.props.onEmployeesAttach}
        />
        {/* <CompanyCurrencyControl companyId={company.id} /> */}
      </div>
    );
  }

  @autobind
  private openDeleteCompanyDialog(): void {
    this.props.onOpenDeleteCompanyDialog(this.props.company.id);
  }

  @autobind
  private onItemClick(): void {
    if (this.props.onClick) {
      this.props.onClick(this.props.company);
    }
  }
}
